<template>
  <abschluss_fehler v-if="vertragStore.hasError"></abschluss_fehler>
  <abschluss_erfolgreich v-else></abschluss_erfolgreich>
</template>

<script setup>

import { useRechnerStore } from '@/stores/rechner';
import { useVertragStore } from '@/stores/vertrag.js';
import abschluss_erfolgreich from '@/components/general/abschluss_erfolgreich.vue'
import abschluss_fehler from '@/components/general/abschluss_fehler.vue'

const store = useRechnerStore();
const vertragStore = useVertragStore();

</script>